import React from 'react';
import { Link } from 'react-router-dom';
import { Images, ArrowRight } from 'lucide-react';
import { mockData } from '../mock';
import { useT } from '../context/LanguageContext';

const GalleryTeaser = () => {
  const { t } = useT();
  return (
    <section id="galleri" className="bg-black py-20 md:py-28" data-testid="gallery-teaser">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-8 md:mb-12">
          <div>
            <p className="text-[#ff2e2e] font-bold uppercase tracking-widest text-sm mb-2 inline-flex items-center gap-2"><Images size={14} /> {t('Galleri')}</p>
            <h2 className="text-4xl md:text-7xl font-bold text-white tracking-tighter" style={{ fontFamily: "'Oktah Round', sans-serif" }}>{t('Slik var stemninga sist')}</h2>
          </div>
          <Link to="/galleri" data-testid="gallery-teaser-link" className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-[#ff2e2e] text-[#ff2e2e] font-bold hover:bg-[#ff2e2e] hover:text-black transition-colors self-start md:self-auto">
            {t('Sjå heile galleriet')} <ArrowRight size={18} />
          </Link>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-5">
          {mockData.gallery.slice(0, 4).map((ph, i) => (
            <Link to="/galleri" key={ph.src} className={`group relative overflow-hidden rounded-2xl md:rounded-3xl bg-[#1a1424] ${i % 3 === 0 ? 'aspect-[3/2] lg:aspect-[4/5]' : 'aspect-[3/2] lg:aspect-[4/5]'}`}>
              <img src={ph.src} alt={ph.alt} loading="lazy" decoding="async" width={2000} height={1333} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GalleryTeaser;
